(() => {
  const purchaseLink = document.querySelector('[data-product-enquiry]');
  if (purchaseLink) {
    const detail = purchaseLink.closest('.product-purchase');
    const baseUrl = purchaseLink.href;
    const update = () => {
      const url = new URL(baseUrl, window.location.origin);
      const selects = [...detail.querySelectorAll('select')];
      if (selects[0]) url.searchParams.set('size', selects[0].value);
      if (selects[1]) url.searchParams.set('grit', selects[1].value);
      const quantity = detail.querySelector('input[type="number"]');
      if (quantity && quantity.validity.valid) url.searchParams.set('quantity', quantity.value);
      purchaseLink.href = url.href;
    };
    detail.addEventListener('input', update);
    detail.addEventListener('change', update);
    update();
  }
  const models = new Set(['Y399', 'MT-32', 'GPC71', 'Y999', 'GXK-51', 'KX-167', 'SCY728', 'XZ-330', 'RCY97', 'GXK56', 'AX-168']);
  const params = new URLSearchParams(window.location.search);
  const product = (window.MOTAI_PRODUCTS || []).find(item => item.id === params.get('product'));
  const model = product ? product.name : params.get('model');
  if (!product && !models.has(model)) return;
  const message = document.querySelector('[data-rfq-message]');
  if (!message || message.dataset.prefilledModel === model) return;
  const language = document.documentElement.lang.split('-')[0];
  const languages = ['zh','es','de','fr','ar','pt','ru','it','ja','ko'];
  const index = languages.indexOf(language);
  const translated = value => { const text = index < 0 ? value : (window.MOTAI_TRANSLATIONS?.[value]?.[index] || value); return language === 'pt' ? text.replace(/Correias/g, 'Cintas').replace(/correias/g, 'cintas') : text; };
  const labels = {en:['Product','Model'],zh:['产品','型号'],es:['Producto','Modelo'],de:['Produkt','Modell'],fr:['Produit','Modèle'],ar:['المنتج','الطراز'],pt:['Produto','Modelo'],ru:['Продукт','Модель'],it:['Prodotto','Modello'],ja:['製品','モデル'],ko:['제품','모델']};
  const prefix = (labels[language] || labels.en)[product ? 0 : 1];
  const line = `${prefix}: ${product ? translated(model) : model}`;
  const knownNames = new Set((window.MOTAI_PRODUCTS || []).flatMap(item => [item.name, ...(window.MOTAI_TRANSLATIONS?.[item.name] || [])]));
  const knownLabels = new Set(Object.values(labels).flat());
  const remaining = message.value.split('\n').filter(value => {
    const colon = value.indexOf(':');
    if (colon < 0 || !knownLabels.has(value.slice(0, colon).trim())) return true;
    const name = value.slice(colon + 1).trim();
    return !models.has(name) && !knownNames.has(name);
  }).join('\n').trim();
  message.value = `${line}${remaining ? '\n\n' + remaining : ''}`;
  const modelField = document.querySelector('[name="contact[model]"]');
  if (modelField) modelField.value = product ? translated(model) : model;
  const category = document.querySelector('[name="contact[category]"]');
  if (category) category.value = product ? product.category : 'Abrasive Belts';
  if (product) {
    for (const key of ['size', 'grit']) {
      const value = params.get(key);
      const allowed = key === 'size' ? product.sizes : product.grits;
      const field = document.querySelector(`[name="contact[${key}]"]`);
      if (field && value && allowed?.map(String).includes(value)) field.value = value;
    }
    const quantity = params.get('quantity');
    if (quantity && /^\d{1,9}$/.test(quantity) && Number(quantity) > 0 && Number(quantity) <= 100000000) {
      const field = document.querySelector('[name="contact[quantity]"]');
      if (field) field.value = quantity;
    }
  }
  message.dataset.prefilledModel = model;
  message.dispatchEvent(new Event('input', { bubbles: true }));
  message.dispatchEvent(new Event('change', { bubbles: true }));
})();
